var render = function render(){var _vm=this,_c=_vm._self._c;return _c('visibility-observer',{staticClass:"infinite-scroll",attrs:{"threshold":0.5},on:{"visible":_vm.process}},[_c('img',{attrs:{"src":"images/loading.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }